import { ReactNode } from "react";
import { Typography, theme } from "antd";

interface SubheadProps {
  children: ReactNode;
  className?: string;
}

export function Subhead({ children, className }: SubheadProps) {
  const { token } = theme.useToken();

  return (
    <Typography.Text
      type="secondary"
      className={className}
      style={{
        fontSize: token.fontSize,
        display: "block",
        marginTop: 0,
      }}
    >
      {children}
    </Typography.Text>
  );
}
